import type { LocalDate, LocalTime } from '../util/datetime';
import type { TimeSlot } from './restaurant';

export type AlternativeKind = 'NEARBY_TIME' | 'ANOTHER_DAY' | 'SMALLER_PARTY';

/** Sugerencia para cerrar el callejón sin salida de "no hay mesa". */
export interface AlternativeSuggestion {
  readonly date: LocalDate;
  readonly time: LocalTime;
  readonly partySize: number;
  readonly kind: AlternativeKind;
}

/**
 * Respuesta de disponibilidad. Un `slots` vacío **no** es un estado vacío que se oculte:
 * es la respuesta a la pregunta del usuario y se muestra explícitamente junto con
 * `alternatives`, que nunca debe quedar sin poblar si el servidor puede ofrecer algo.
 */
export interface Availability {
  readonly restaurantId: string;
  readonly date: LocalDate;
  readonly partySize: number;
  readonly slots: readonly TimeSlot[];
  readonly alternatives: readonly AlternativeSuggestion[];
  readonly closedThatDay: boolean;
}

export function hasSlots(availability: Availability): boolean {
  return availability.slots.some((slot) => slot.available);
}
